import {
  addBreadcrumb,
  browserTracingIntegration,
  captureException,
  captureMessage,
  getCurrentScope,
  init,
} from "@sentry/browser";
import { forEachObjIndexed } from "ramda";

import { ReactError } from "./errors";

if (env.SENTRY_CLIENT_DSN) {
  init({
    dsn: env.SENTRY_CLIENT_DSN,
    environment: env.SENTRY_CURRENT_ENV,
    allowUrls: [/https?:\/\/((assets|www)\.)?korukids\.co\.uk/],
    release: env.HEROKU_BUILD_COMMIT,
    integrations: (integrations) => [
      ...integrations,
      browserTracingIntegration(),
    ],
    tracesSampleRate: 0.2,
    attachStacktrace: false,
    /* eslint-disable object-shorthand, no-param-reassign, func-names, prefer-const, prefer-destructuring */
    beforeSend: function (event, hint) {
      let originalException = hint.originalException;

      // always tag messages we've explicitly logged as react
      // so we see them in Sentry
      if (!event.exception && event.message) {
        event.tags = event.tags || {};
        event.tags.react = "yes";
      }

      if (originalException instanceof ReactError) {
        event.tags = event.tags || {};
        event.tags.react = "yes";
        event.tags.rendered = event.tags.rendered || "yes";

        event.extra = event.extra || {};

        forEachObjIndexed(function (value, key) {
          event.extra[key] = value;
        }, originalException.extra);
      }

      // Drop `Unexpected token ';'.` SyntaxErrors, whilst we're facing a lot of them.
      if (
        event.tags?.react !== "yes" &&
        originalException instanceof SyntaxError &&
        originalException.message.includes("Unexpected token ';'")
      ) {
        return null;
      }

      // Network issues between a user's device and Apple; we can't do anything about these
      if (originalException.message === "[Apple MapKit JS] Network Error") {
        return null;
      }

      return event;
    },
    /* eslint-enable */
  });

  if (global.current) {
    getCurrentScope().setUser({ id: global.current.user.id });
  }
}

// Only the methods the app uses are re-exported: `export default Sentry` with
// a namespace import marks every @sentry/browser export as used, which drags
// replay/feedback/canvas code into the bundle.
export default {
  addBreadcrumb,
  captureException,
  captureMessage,
  getCurrentScope,
};
